import { goURL } from '../../../webmodule-common/other/ui/resource-resolver';
export const resourceQuote = 'Quote';
export async function launchQuote(id: string) {
  goURL(resourceQuote, id);
  return true;
}
